var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navBack',{attrs:{"title":"入会须知"}}),_c('div',{staticClass:"zjxNotice"},[_c('div',{staticClass:"zxj_notice"},[_c('div',{staticClass:"zxj_notice__detail",domProps:{"innerHTML":_vm._s(_vm.join_paper)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }